import React from 'react';
import { Button } from 'react-bootstrap';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import chartUtils from '../../common/services/chartUtils';

export const renderExportButton = (data, fileName, t) => {
	return <Button
		style={{ float: 'right', border: 'none', background: 'transparent', cursor: 'pointer' }}
		onClick={() => chartUtils.exportCsv(data, fileName)}
		title={t('Common_ExportCSV')}>
		<FontAwesomeIcon icon={faDownload} />
	</Button>;
}

export { default, COLORS } from '../../common/services/chartUtils';